export const keyify = string => string.replace(/\s/g, "-").toLowerCase();
